const merchantTest = {
    path: 'merchantTest',
    component: resolve => require(['@/pages/admin/reviewed/wechat/merchantTest'], resolve),
    meta: {isAccredit: true}
  }

  export default merchantTest
